import { createBrowserRouter } from 'react-router-dom';
import { AppShell } from './AppShell.js';
import { NavigateScreen } from '../features/nav/NavigateScreen.js';
import { TracksListScreen } from '../features/tracks/TracksListScreen.js';
import { TrackDetailScreen } from '../features/tracks/TrackDetailScreen.js';
import { SettingsScreen } from '../features/offline/SettingsScreen.js';
import { BoatScreen } from '../features/boat/BoatScreen.js';
import { PlannerScreen } from '../features/route/PlannerScreen.js';
import { AuthScreen } from '../features/account/AuthScreen.js';
import { ShareViewerScreen } from '../features/share/ShareViewerScreen.js';

// Routes per spec 00. Feature screens land in later phases; stubs keep the
// shell and navigation testable now.
export const router: ReturnType<typeof createBrowserRouter> = createBrowserRouter([
  // Trip-sharing viewer (spec 15) — deliberately OUTSIDE AppShell: no tabs, no
  // disclaimer gate, no account. A stranger with the link only ever sees this.
  {
    path: '/del/:id',
    element: <ShareViewerScreen />,
  },
  {
    path: '/',
    element: <AppShell />,
    children: [
      { index: true, element: <NavigateScreen /> },
      {
        path: 'plan',
        element: <PlannerScreen />,
      },
      {
        path: 'turer',
        element: <TracksListScreen />,
      },
      {
        path: 'turer/:id',
        element: <TrackDetailScreen />,
      },
      {
        path: 'innstillinger',
        element: <SettingsScreen />,
      },
      {
        path: 'baat',
        element: <BoatScreen />,
      },
      {
        path: 'logg-inn',
        element: <AuthScreen mode="login" />,
      },
      {
        path: 'registrer',
        element: <AuthScreen mode="register" />,
      },
      {
        path: 'glemt-passord',
        element: <AuthScreen mode="reset" />,
      },
    ],
  },
]);
